import React from 'react';
import { useRouteProps } from './useRouteProps';

export type OnEnter = (event: React.KeyboardEvent) => void;

export interface UseOnEnter {
    claimNumberOnEnter: OnEnter;
    zipCodeOnEnter: OnEnter;
}

export const useOnEnter = (): UseOnEnter => {
    const { onClick } = useRouteProps();

    return {
        zipCodeOnEnter: ({ key }) => {
            if (key === 'Enter') {
                document.getElementById('zip-code-input')?.blur();
                onClick();
            }
        },
        claimNumberOnEnter: ({ key }) => {
            if (key === 'Enter') {
                const zipCodeInput: HTMLElement | null = document.getElementById('zip-code-input');
                if (zipCodeInput) {
                    zipCodeInput.focus();
                }
            }
        },
    };
};
